import { render, staticRenderFns } from "./hollow.vue?vue&type=template&id=2df1c1b2&scoped=true"
import script from "./hollow.vue?vue&type=script&lang=js"
export * from "./hollow.vue?vue&type=script&lang=js"
import style0 from "./hollow.vue?vue&type=style&index=0&id=2df1c1b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df1c1b2",
  null
  
)

export default component.exports